import angular from 'angular';
import dcReportcardController from './reportcard.controller'
import dcReportcard from './reportcard.directive'
export default angular.module( 'directives.reportcard', [] )
    .directive( 'dcReportcard', dcReportcard )
    .controller( 'dcReportcardController', dcReportcardController );
